import VideoClosedCaptionsIcon from '@atlaskit/icon-lab/core/video-closed-captions';
import * as React from 'react';

export function SvgCCOff() {
  return <VideoClosedCaptionsIcon label="" testId="ads-refreshed-icon" />;
}
